type Indexable = { index?: { sortIndex: number } | null };
type Nameable = { name: string };

export function sortByIndex<T extends Indexable & Nameable>(
  a: T,
  b: T,
  indexingEnabled: boolean,
): number {
  if (indexingEnabled) {
    return (a.index?.sortIndex ?? 0) - (b.index?.sortIndex ?? 0);
  }

  // Check if both names start with a number followed by a period
  const aMatch = a.name.match(/^(\d+)\./);
  const bMatch = b.name.match(/^(\d+)\./);

  if (aMatch && bMatch) {
    // If both match the pattern, compare the parsed numbers
    const aNum = parseInt(aMatch[1]);
    const bNum = parseInt(bMatch[1]);
    return aNum - bNum;
  }

  return a.name.localeCompare(b.name);
}
